module.exports = __webpack_public_path__ + "static/Game-of-kaken-b67f050e9ec33a7e85c7424a86208515.pdf";